/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/formDefaults.ts
 🗓️ Created: 2025-01-27
 🧩 Description:
    Default values and factories for DISA Entries forms.
────────────────────────────────────────────────────────────────*/

import { DisaSettings, FormState } from '../types';

/**
 * Default DISA settings
 */
export const DEFAULT_SETTINGS: DisaSettings = {
  dialPrefix: '',
  callerIdName: '',
  callerIdNumber: '',
  inheritCallerId: false,
  greeting: '',
  invalidPinSound: 'ivr/ivr-that_was_an_invalid_entry.wav',
  timeoutSound: 'ivr/ivr-time_out.wav',
  responseTimeout: 10,
  digitTimeout: 5,
  maxCallDuration: 1800,
  maxAttempts: 3,
  hangupOnFail: true,
  recordCall: false,
  logAccess: true,
  allowLocal: true,
  allowInternational: false,
  ipRestriction: [],
  scheduleWindow: null,
  retryOnFail: false,
  notifyOnAccess: ''
};

/**
 * Default form state
 */
export const DEFAULT_FORM_STATE: FormState = {
  name: '',
  context: '',
  password: '',
  classOfServicesId: null,
  enabled: true,
  settings: { ...DEFAULT_SETTINGS, ipRestriction: [] }
};

/**
 * Get default form state
 */
export function getDefaultFormState(): FormState {
  return { ...DEFAULT_FORM_STATE };
}

